export const LOG_IN_REQUEST = "LOG_IN_REQUEST";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_ERROR = "LOG_IN_ERROR";
export const CLEAR_LOG_IN_FLAG = "CLEAR_LOG_IN_FLAG";
